import { FC, useCallback } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useCancelPoApi from 'src/services/useCancelPoApi';
import { useContextSelector } from 'use-context-selector';
import usePoButtonState from '../invoice_details/usePoButtonState';
import { PoRelatedDocumentsContext } from '../po_related_documents/PoRelatedDocumentsContext';

interface CancelPOProps {
  poId: number;
}

const CancelPo: FC<CancelPOProps> = ({ poId }) => {
  const poDetails = useContextSelector(PoRelatedDocumentsContext, (value) => value.poDetails);

  const { refreshPage, isReceiptActionButtonsDisabled, getMessages } = useReceiptDetails();
  const { cancelPo, cancelPoCallLoading } = useCancelPoApi();
  const [cancelPoMessages, cancelPoButtonState] = usePoButtonState(
    poDetails?.triggerPreCheck || [],
    'Cancel'
  );

  const handleCancelPo = useCallback(async () => {
    try {
      await cancelPo({ poIds: [poId] });
    } catch (error) {
      console.error(error);
    } finally {
      refreshPage();
    }
  }, [cancelPo, poId, refreshPage]);

  const isDisabled = isReceiptActionButtonsDisabled(isButtonDisabled(cancelPoButtonState));

  return (
    <PopUp
      popupAlign={{ horizontal: 'center', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[350px]">
          <PopUpContentWrapper
            type="Error"
            contents={getMessages(isButtonDisabled(cancelPoButtonState) ? cancelPoMessages : [])}
          />
        </div>
      }
      show={isDisabled}
    >
      <Button
        onClick={handleCancelPo}
        color="error"
        buttonState={cancelPoButtonState}
        loading={cancelPoCallLoading}
        disabled={isDisabled}
      >
        Cancel PO
      </Button>
    </PopUp>
  );
};

export default CancelPo;
